export const WIDGET_CATEGORY_DASHBOARD = 'Dashboard';
export const WIDGET_CATEGORY_MONITORING = 'Monitoring';
export const WIDGET_CATEGORY_MANUAL_SEARCH = 'Manual search';
